<template>
  <div class="progress">
    <div class="banner"></div>
    <div class="fz">
      <div class="conter" style="padding-top: 2em">
        <div class="jdjb-title">
          <img src="../assets/images/jdjbtbzb.png" alt="" class="jjjc-img" />
          <span>举报方式</span>
          <img src="../assets/images/jdjbtbyb.png" alt="" class="jjjc-img" />
        </div>
        <div class="jbjb-content">
          <div class="list-item">
            <img src="../assets/images/jdjbicon1.png" alt="" />
            <p>举报电话</p>
            <span>027-87257900</span>
          </div>
          <div class="list-item" style="padding-top: 3em">
            <img src="../assets/images/jdjbicon2.png" alt="" />
            <p>来信来访</p>
            <span
              >武昌区民主路782号<br />
              洪广宝座第12,24层
            </span>
            <h5>湖北省人才发展集团综合办公室（收）</h5>
          </div>
          <div class="list-item">
            <img src="../assets/images/jdjbicon3.png" alt="" />
            <p>举报邮箱</p>
            <span>srcjtjj@jobhb.com</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "feedback",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/jjjcpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}
.conter {
  max-width: 70%;
  margin: 0 auto;
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

/* 监督举报页面 */
.jdjb-title {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding-top: 1em;
  margin-bottom: 2em;
}

.jdjb-title img {
  vertical-align: middle;
  height: 0.3em;
  margin: 0 1em;
  width: 10em;
}

.jdjb-title span {
  font-size: 1.5em;
  font-weight: 600;
  color: #cda667;
  text-align: center;
  white-space: nowrap;
  display: block;
}

.jbjb-content {
  margin-top: 4em;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.jbjb-content .list-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 18em;
  height: 18em;
  box-sizing: border-box;
  border-radius: 0.5em;
  border: 1px solid #efefef;
}

.jbjb-content .list-item img {
  width: 5.5em;
  height: 5.5em;
}

.jbjb-content .list-item p {
  width: 4em;
  font-weight: bold;
  color: #cda667;
  font-size: 1.275em;
  margin: 1em 0 0.85em 0;
}

.jbjb-content .list-item span {
  font-size: 1.025em;
  text-align: center;
  font-weight: bold;
}

.jbjb-content .list-item h5 {
  font-size: 0.9em;
  text-align: center;
  color: #aba8a8;
  margin-top: 0.7em;
}
</style>
